import { useSelector } from 'react-redux';
import styled from 'styled-components';

const Footer = () => {
  const appVersion = useSelector((state) => state.appInfo.version);

  return (
    <Wrapper>
      <Version>Version: {appVersion}</Version>
    </Wrapper>
  );
}

export default Footer;

const Wrapper = styled.footer`
  padding: 50px;
`;

const Version = styled.div`
  --footer-bg: #9c9c9c;

  text-align: center;
  color: var(--footer-bg);
`;